import { store } from '@betacrew/jars-flux'
export const componentKey = "FORMS/FORMS_SECTION";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setSaveSingleFormSuccessData: (state, action) => {
            state.saveSingleFormSuccessData = action.payload
        },
        setFinalSaveSingleFormData: (state, action) => {
            state.finalSaveSingleFormData = action.payload;
        },
    }, 
    initialReducerState: {
        saveSingleFormSuccessData: null,
        finalSaveSingleFormData: {},
    }
});
export const {
    setSaveSingleFormSuccessData,
    setFinalSaveSingleFormData,
} = actions;